
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  ref,
  watch,
} from "vue";
import { useRouter } from "vue-router";
import { getUserInfo, parseImgUrl } from "@/utils";
import { UserActionTypes } from "@/store/modules/user/action-types";
import { useStore } from "@/store";
import { switchoverSceneHttp } from "@/apis/envmonitor";

export default defineComponent({
  props: {
    projectId: {
      type: String,
      default: () => "",
    },
    spaceId: {
      type: String,
      default: () => "",
    },
    scenarioArr: {
      type: Array,
      default: () => [],
    },
    activeType: {
      type: String,
      default: () => "",
    },
  },
  setup(props, contx) {
    let router: any = useRouter();
    const store = useStore();
    let scenarioImgArr: any = {
      DISCUSSING: parseImgUrl("ipdImages", "taolun.svg"),
      PROJECTING: parseImgUrl("ipdImages", "touying.svg"),
      ADJOURNMENT: parseImgUrl("ipdImages", "sanhui.svg"),
    };
    let scenarioArr: any = [];
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      spaceId: props.spaceId,
      scenarioArr: scenarioArr,
      scenarioImgArr: scenarioImgArr,
      activeType: props.activeType,
      onSubmit(values: any) {
        router.push({ path: "/choice-project" });
      },
      formatScenarioImg() {
        // debugger
        proxyData.scenarioArr.map((item: any) => {
          item.img = proxyData.scenarioImgArr[item.sceneType];
          if (item.sceneType === "DISCUSSING") {
            item.order = 1;
          } else if (item.sceneType === "PROJECTING") {
            item.order = 2;
          } else if (item.sceneType === "ADJOURNMENT") {
            item.order = 3;
          } else {
            item.order = 4;
          }
        });
        // 数组排序
        proxyData.scenarioArr = proxyData.scenarioArr.sort(
          (a: any, b: any) => a.order - b.order
        );
      },
      // 切换场景
      handleScene(item: any) {
        // 展示场景详情页面
        // proxyData.activeType = item.sceneType;
        const userInfo: any = getUserInfo();
        const params = {
          spaceId: proxyData.spaceId,
          projectId: props.projectId,
          type: item.sceneType,
          pubname: userInfo.pubname,
        };

        item.loading = true;
        item.lodingText = "正在切换至";
        contx.emit("setHeadScene", item, 1);
        switchoverSceneHttp(params)
          .then((res) => {
            let resData: any = res;
            if (resData.result === "success") {
              item.loading = false;
              item.lodingText = "切换至";
              contx.emit("setHeadScene", item, 2);
            }
          })
          .catch(() => {
            item.loading = false;
            item.lodingText = "";
            contx.emit("setHeadScene", item, 2);
          });
      },
    });
    watch(
      props,
      (newProps: any) => {
        proxyData.activeType = newProps.activeType;
        proxyData.scenarioArr = newProps.scenarioArr;
        proxyData.spaceId = newProps.spaceId;
        proxyData.formatScenarioImg();
        console.log("会议室场景变化了--");
      },
      {
        deep: false,
        immediate: true,
      }
    );
    onMounted(() => {});
    return {
      ...toRefs(proxyData),
    };
  },
});
